export default __webpack_public_path__ + "assets/93a84427630640ba37250d64c05654f8.png";